var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-Print",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share-Icon",
    transform: "translate(0 -.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Spacer-square",
    width: 64,
    height: 64,
    y: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#3C444D",
    strokeWidth: 2,
    transform: "translate(20 21)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6 0 6 5 18 5 18 0",
    transform: "matrix(1 0 0 -1 0 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19,8.24596879 L19.75,8.24596879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    d: "M18,20.5 L18,17.5 L22,17.5 C22.5522847,17.5 23,17.0522847 23,16.5 L23,6.5 C23,5.94771525 22.5522847,5.5 22,5.5 L2,5.5 C1.44771525,5.5 1,5.94771525 1,6.5 L1,16.5 C1,17.0522847 1.44771525,17.5 2,17.5 L6,17.5 L6,20.5 C6,21.0522847 6.44771525,21.5 7,21.5 L17,21.5 C17.5522847,21.5 18,21.0522847 18,20.5 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 12,
    height: 10,
    x: 6,
    y: 11.5,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.8e1c862ab00d14a270e48bea7180a8c6.svg";
export { ForwardRef as ReactComponent };